/**
 * Returns true only when `value` parses as a URL whose protocol is
 * `http:` or `https:`. Rejects `javascript:`, `data:`, `vbscript:`,
 * `file:`, and anything else that isn't a real web URL.
 *
 * Use this anywhere user-controlled URLs are navigated to — passing
 * a `javascript:` URI to `window.location.assign` or an `<a href>`
 * executes the payload in the current document's origin.
 */
export function isHttpUrl(value: string | null | undefined): value is string {
  if (!value) return false;
  try {
    const parsed = new URL(value);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

/** A show's ticket CTA: its absolute http(s) `ticket_link`, else its Punchup show page. */
export function showTicketUrl(show: {
  id: string;
  ticket_link?: string | null;
}): string {
  const link = show.ticket_link?.trim();
  return isHttpUrl(link) ? link : `https://punchup.live/show/${show.id}`;
}
